<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Ethan Alexander was a marine engineer, spending 15 years tearing apart and rebuilding the guts of the engine room. He now spends his time at home, annoying his wife with crazy and funny jokes and noises.</p><br/>
<p style="text-indent: 00em;">He is an avid reader, with 1,000 books taking up space in every room in the house, which annoys his wife to no end.</p><br/>
<p style="text-indent: 00em;">He wrote this book as a way to de-stress and focus the mind after suffering mental health issues in the past.</p><br/>
<p style="text-indent: 00em;">He likes being home with his family, as he missed this before.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7cc49086